export default "/kiban/_next/static/images/05_4L_other-cbb3eaaa9f2f12013ce8a040d1f7309e.png";